// extracted by mini-css-extract-plugin
export default {"chatBox":"ReclamationsDetails_chatBox__ZRC2v","createdAt":"ReclamationsDetails_createdAt__QIP1m"};